import { phoneNumbers } from "shared";
import { ButtonRow } from "../ButtonRow";

type ErrorRowProps = {
  resetErrorBoundary: () => void;
};

/** Used by `<ErrorBoundary/>` as a `FallbackComponent` */
export const ErrorRow = ({ resetErrorBoundary }: ErrorRowProps) => {
  return (
    <ButtonRow
      label={`Something went wrong. Please try again or call ${phoneNumbers.auto} for assistance.`}
      onClick={resetErrorBoundary}
    >
      Try again
    </ButtonRow>
  );
};
